'use client'

import { SegmentError } from '../_error-boundaries/segment-error.client'

type BeachChairErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function BeachChairError(props: BeachChairErrorProps) {
  return <SegmentError boundary="beach-chair" {...props} />
}
